import React, { useEffect, useState, useRef } from "react";
import Icon1 from "../icons/Icon";
import TextField2T from "./TextField2T";
const SearchAlgolia = ({
  inputValue = "",
  setInputValue,
  options = [],
  placeholder = "Rechercher...",
  onAction,
  classNameCustom = "w-c400",
  start_only = true,
  visible_empty = false,
  show_options = true,
  debounceDelay = 1000, // Configurable debounce delay in milliseconds
  textfield2t_mode = false,
  focus_on_start = false, // Focus input on start
  children = null,
  navigateWorkspace = () => {},
}) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [localInputValue, setLocalInputValue] = useState(inputValue);
  const debounceRef = useRef(null);
  const isLoading = useRef(false);
  // Function to render highlighted text with search suggestions

  // Sync local value with external inputValue when it changes externally
  useEffect(() => {
    setLocalInputValue(inputValue);
  }, [inputValue]);

  // Debounced effect to update external inputValue
  useEffect(() => {
    // Clear existing timeout
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    // Only debounce if there's actually a change and the component is mounted
    if (localInputValue !== inputValue) {
      isLoading.current = true;

      debounceRef.current = setTimeout(() => {
        setInputValue(localInputValue);
        isLoading.current = false;
      }, debounceDelay);
    }

    // Cleanup timeout on unmount
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [localInputValue, inputValue, setInputValue, debounceDelay]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setLocalInputValue(value);

    // Show/hide dropdown based on local value for immediate UI feedback
    if (value) {
      setIsDropdownVisible(true);
    } else {
      setIsDropdownVisible(false);
    }
  };

  const resetSearch = () => {
    // Clear any pending debounce
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    isLoading.current = false;

    if (visible_empty) {
      setIsDropdownVisible(true);
      setLocalInputValue("");
      setInputValue("");
    } else {
      setLocalInputValue("");
      setInputValue("");
      setIsDropdownVisible(false);
      let option = { label: "" };
      onAction(option);
    }
  };

  const handleOptionClick = (e, option) => {
    console.log("clicked option", option);
    e.stopPropagation();

    // Clear any pending debounce
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    isLoading.current = false;
    setLocalInputValue(option.label);
    setInputValue(option.label);
    let navigated = onAction(option);
    setIsDropdownVisible(false);
    if (!navigated) {
      try {
        navigateWorkspace(`/folder/${option.value}`);
      } catch (error) {
        console.error("Navigation error:", error);
      }
    }
    setFocus(false);
    setTimeout(() => setIsDropdownVisible(false), 150);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // Clear debounce and immediately update
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      isLoading.current = false;
      setInputValue(localInputValue);
      setIsDropdownVisible(false);

      if (!show_options) {
        onAction("enter");
      }
    }
  };

  const [focus, setFocus] = useState(false);

  return (
    <div className="relative h-10">
      {focus && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setFocus(false);
            setTimeout(() => setIsDropdownVisible(false), 150);
          }}
          className="fixed   top-0 left-0 w-full h-full  bg-shadow_25 z-10 "
        ></div>
      )}
      <div
        className={`
        ${focus ? " outline-none border-2 z-20 outline-1 fixed bg-white outline-blue-100 border-blue-300" : "border-gray-400"}
        ${classNameCustom}
        h-10    flex gap-2 select-none rounded-full border-1    `}
      >
        <div className="flex  flex-row w-full items-center   ">
          <svg
            className="w-5 ml-4 h-5 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>

          <input
            type="text"
            value={localInputValue}
            onFocus={() => {
              setFocus(true);
              visible_empty && setIsDropdownVisible(true);
            }}
            autoFocus={focus_on_start}
            // onBlur={() => {
            //   setFocus(false);
            //   setTimeout(() => setIsDropdownVisible(false), 150);
            //   // Delay closing the dropdown to allow click events on it to register
            //   // setTimeout(() => setIsDropdownVisible(false), 150);
            // }}
            onKeyDown={handleKeyDown}
            onChange={handleInputChange}
            placeholder={placeholder}
            className="w-full px-4 py-2 text-h3 border-none outline-none bg-transparent"
          />
        </div>

        {isDropdownVisible && show_options && (
          <ul className="absolute z-20 w-fit scroll-ba min-w-c300 mt-12 py-2 pr-6 bg-white rounded-xl shadow-xl max-h-c300 shadow-shadow_10 border scrollbar-none overflow-y-auto">
            {isLoading?.current ? (
              <li className="px-4 py-2 text-h3 text-gray-500 flex items-center gap-2">
                <div className="animate-spin h-4 w-4 border-2 border-gray-400 border-t-transparent rounded-full"></div>
                Recherche en cours...
              </li>
            ) : options.length > 0 ? (
              options.map((option, index) => (
                <li
                  key={index}
                  onClick={(e) => handleOptionClick(e, option)}
                  className="px-4 py-2 cursor-pointer hover:bg-neutral-50 flex flex-row gap-2"
                >
                  <div className="text-h3 flex items-center gap-4">
                    <svg
                      className="w-4 h-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                    {renderHighlightedText(
                      option.label +
                        (option.extra_label ? ` - ${option.extra_label}` : "") +
                        (option.extra_label_2
                          ? ` - ${option.extra_label_2}`
                          : ""),
                      localInputValue
                    )}
                  </div>
                </li>
              ))
            ) : (
              localInputValue && (
                <li className="px-4 py-2 text-h3 text-gray-500">
                  Aucun résultat trouvé
                </li>
              )
            )}
          </ul>
        )}

        <div
          className={`${
            localInputValue ? "text-black" : "text-white"
          } flex cursor-pointer min-h-full text-h3 items-center pr-4 justify-center `}
          onClick={resetSearch}
        >
          Effacer
        </div>
        {children && (
          <div className="flex items-center  justify-center">{children}</div>
        )}
      </div>{" "}
    </div>
  );
};

export default SearchAlgolia;

export const renderHighlightedText = (text, searchValue) => {
  if (!searchValue.trim()) {
    return <span className="text-gray-500">{text}</span>;
  }

  const searchLower = searchValue.toLowerCase();
  const textLower = text.toLowerCase();
  const matchIndex = textLower.indexOf(searchLower);

  if (matchIndex === -1) {
    return <span className="text-gray-500">{text}</span>;
  }

  const beforeMatch = text.substring(0, matchIndex);
  const match = text.substring(matchIndex, matchIndex + searchValue.length);
  const afterMatch = text.substring(matchIndex + searchValue.length);

  return (
    <span>
      <span className="text-gray-400">{beforeMatch}</span>
      <span className="text-black font-medium">{match}</span>
      <span className="text-gray-400">{afterMatch}</span>
    </span>
  );
};
